'use client'

import { IconInfoCircle } from '@macarongfactory/web-icons'
import { BottomSheet, Text } from '@macarongfactory/web-ui'
import { useState } from 'react'

interface IInfoSheetProps {
  /** 바텀시트 제목 */
  title: string
  /** 헤더 하단 한 줄 설명 (단일 안내용) */
  description?: string
  /** 본문 여러 줄 안내 (목록형) */
  lines?: string[]
  /** 스크린리더용 버튼 라벨 */
  ariaLabel: string
  /** ⓘ 아이콘 크기(px) */
  iconSize?: number
}

const DEFAULT_ICON_SIZE = 18

/**
 * ⓘ 클릭 시 설명 BottomSheet를 여는 인포 버튼.
 * (실연비 게이지의 공인연비 / 평균 실연비 설명에 사용)
 */
const InfoSheet = ({
  title,
  description,
  lines,
  ariaLabel,
  iconSize = DEFAULT_ICON_SIZE,
}: IInfoSheetProps) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type='button'
        aria-label={ariaLabel}
        onClick={() => setOpen(true)}
        className='inline-flex text-foreground-neutral-assistive'
      >
        <IconInfoCircle width={iconSize} height={iconSize} />
      </button>
      <BottomSheet
        open={open}
        onClose={() => setOpen(false)}
        dismissOnClickOutside
        top={
          <BottomSheet.Top.LeftAlignedHeader
            title={title}
            lower={description}
          />
        }
        content={
          lines && lines.length > 0 ? (
            <BottomSheet.Content>
              {/* Figma 7809-18671: 불릿 리스트(lineTypes UNORDERED), 좌우 px16(x4), gap4, neutral-normal */}
              <ul className='flex flex-col gap-dimension-x1 px-dimension-x4'>
                {lines.map(line => (
                  <li key={line} className='flex gap-dimension-x1'>
                    <Text
                      as='span'
                      variant='body-1-medium'
                      color='text-foreground-neutral-normal'
                      aria-hidden
                    >
                      •
                    </Text>
                    <Text
                      as='span'
                      variant='body-1-medium'
                      color='text-foreground-neutral-normal'
                      className='flex-1 break-keep'
                    >
                      {line}
                    </Text>
                  </li>
                ))}
              </ul>
            </BottomSheet.Content>
          ) : undefined
        }
        bottom={
          <BottomSheet.Bottom.BottomCTA.Vertical
            gradation={false}
            mainButton={
              <BottomSheet.Bottom.MainButton.SolidButton
                text='확인'
                onClick={() => setOpen(false)}
              />
            }
          />
        }
      />
    </>
  )
}

export default InfoSheet
